import { FC } from 'react';

const LoginSidePanal: FC = () => {
  return (
    <div className='flex-1 xxs:hidden md:block md:pt-10'>
      <div className='md:bg-login-Img h-full bg-contain bg-right-bottom bg-no-repeat' />
    </div>
  );
};

export default LoginSidePanal;
